import { styled } from '../../base';
import { TOP_HEADER_HEIGHT } from '../../common';
export const StyledOpenPositionsPageWrap = styled('div')<{
    isEntityPath: boolean;
}>(({ isEntityPath }) => ({
    display: isEntityPath ? 'none' : 'inherit',
    height: `calc(100vh - ${TOP_HEADER_HEIGHT}px)`,
}));
